import { render, staticRenderFns } from "./CalcPrice.vue?vue&type=template&id=15cf49ce"
import script from "./CalcPrice.vue?vue&type=script&lang=js"
export * from "./CalcPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports